import { render, staticRenderFns } from "./lazy_display_frozenpanetable_xy.vue?vue&type=template&id=ed3fcbca&"
import script from "./lazy_display_frozenpanetable_xy.vue?vue&type=script&lang=js&"
export * from "./lazy_display_frozenpanetable_xy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports